export default "__VITE_ASSET__B6WHx2s___"